export var PlaceOrderStrings = {
    title: function () { return 'Place an order'; },
};
export var CreateBudgetPlaceOrderStrings = {
    description1: function () {
        return 'Create one-time budget that will apply towards your order.';
    },
    expireDescription: function (numDays) {
        return "This budget will expire in " + numDays + " days after creation.";
    },
    cta: {
        text: function () { return 'Start Order'; },
        captionText: function () {
            return 'This will redirect to www.doordash.com to place an order with this budget.';
        },
    },
    labels: {
        budgetName: function () { return 'Budget Name'; },
        budgetAmount: function () { return 'Budget Amount ($)'; },
    },
    placeholders: {
        budgetName: function () { return 'Office Lunch'; },
    },
    errors: {
        budgetNameIsRequired: function () { return 'Budget name is required.'; },
        budgetAmountIsRequired: function () { return 'Budget amount is required.'; },
        budgetAmountShouldBeNumber: function () { return 'Budget amount should be a number.'; },
        budgetNotCreatedPleaseTryAgain: function () {
            return 'Budget not created. Please try again.';
        },
    },
    toastMsg: {
        success: function (budgetName) { return "'" + budgetName + "' created sucessfully."; },
    },
};
export var NonEmPlaceOrderStrings = {
    description: function () {
        return 'Click "Start Order" to navigate to www.doordash.com and place an order for your team.';
    },
    cta: {
        text: function () { return 'Start Order'; },
    },
    faqs: {
        title: function () { return 'Frequently Asked Questions'; },
        faq1: {
            question: function () {
                return 'How can I easily enable employees to select their own meals and have it delivered together?';
            },
            step1: function () { return 'Tap on the Start Order button above'; },
            step2: function () { return 'Find a store that you would like to order from'; },
            step3: function () { return 'Tap on the Group Order button to start a group order'; },
            step4: function () {
                return 'Share your group cart link with the team, and ask them to add their favorite food';
            },
            step5: function () { return 'Check out your group cart and enjoy your meal together'; },
        },
        faq2: {
            question: function () { return 'How can I order catering?'; },
            step1: function () { return 'Tap on the Start Order button above'; },
            step2: function () {
                return 'Tap on the Catering option from the top of the page to view catering stores near you';
            },
            step3: function () {
                return 'Place the group order and enjoy your meal together once delivered!';
            },
        },
    },
};
export var AccessibilityStrings = {
    open: function () { return 'open button'; },
    close: function () { return 'close button'; },
};
